import { constant, Decoder, number, object, string, union } from '@mojotech/json-type-validation'

import { JudgeCase } from '@/domain/entities/judge/judgeCase'

export const judgeCaseDecoder: Decoder<JudgeCase> = object({
  caseName: union(string(), constant(null)),
  cpuTime: union(number(), constant(null)),
  inputSize: union(number(), constant(null)),
  label: string(),
  memory: union(number(), constant(null)),
  outputSize: union(number(), constant(null)),
  serial: number(),
  status: string()
})
